"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUuid = void 0;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const isValidUuid = (str) => UUID_REGEX.test(str);
exports.isValidUuid = isValidUuid;
